import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';
import { transformDateStringFrance } from '@/utilities/datetime';
import { useActionLogs } from '@/hooks/item';
import { ActionLogType } from '@/types/item';
import useTable from '@/hooks/table';

const defaultPageSize = 5;

const ActionLog: React.FC<{ id: number; type: ActionLogType }> = ({ id, type }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const { page, pageSize, totalItems, onPageChange, persistTotalItems } = useTable(defaultPageSize);

  const { data: actionLogs, isFetching } = useActionLogs({
    type,
    id,
    page,
    pageSize,
    enabled: open,
  });

  useEffect(() => {
    if (actionLogs) persistTotalItems(actionLogs.total);
  }, [actionLogs]);

  const columns: GridColDef[] = [
    { field: 'time', headerName: t('item.actionLog.time') },
    { field: 'action', headerName: t('item.actionLog.action') },
    { field: 'by', headerName: t('item.actionLog.by') },
    { field: 'comment', headerName: t('item.actionLog.comment') },
  ];

  const rows: GridValidRowModel[] = actionLogs
    ? actionLogs.data.map((item) => {
        return {
          id: item.id,
          time: transformDateStringFrance(item.createdAt),
          comment: item.comment,
          by: item.createdBy,
          action: item.action,
        };
      })
    : [];

  return (
    <Container
      title={t('item.actionLog.title')}
      handler={{ open, setOpen }}
      actions={[]}
      testId="action_log"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={isFetching}
        table={{
          kind: 'DynamicTable',
          totalItem: totalItems,
          pageSize,
          pageSizeOptions: [defaultPageSize, 10, 15, 20],
          onPageChange,
        }}
      />
    </Container>
  );
};

export default ActionLog;
